<script setup lang="ts">
import { isLocalhost } from '~/utils/consts'

useHead({
  bodyAttrs: {
    class: 'dark:bg-gray-950'
  }
})
const { moduleId } = storeToRefs(useRouterStore())
const { setup } = storeToRefs(useSystemStore())
</script>

<template>
  <div class="h-screen flex flex-col items-center justify-center gap-4 overlay">
    <div class="gradient" />
    <UColorModeButton
      size="sm"
      class="absolute top-16"
    />
    <UBadge
      v-if="moduleId"
      :label="moduleId"
      variant="subtle"
      class="absolute top-8"
    />
    <div class="flex flex-wrap gap-2">
      <UButton
        v-for="module in isLocalhost ? ['clinux', 'portal', 'resultado', 'questionario', 'otrs', 'medico'] : []"
        :key="module"
        :label="module"
        :to="`/${module}`"
        size="sm"
      />
    </div>
    <slot />
    <UBadge
      v-if="setup?.nr_clinux"
      :label="`Api ${setup.nr_clinux} Web ${setup.nr_portal} Dba ${setup.nr_banco}`"
      variant="soft"
      class="absolute bottom-8"
    />
  </div>
</template>

<style scoped>
.gradient {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(50% 50% at 50% 50%, rgb(var(--color-primary-500) / 0.25) 0, #fff 100%);
}

.dark {
  .gradient {
    background: radial-gradient(
      50% 50% at 50% 50%,
      rgb(var(--color-primary-400) / 0.1) 0,
      rgb(var(--color-gray-950)) 100%
    );
  }
}

.overlay {
  background-size: 100px 100px;
  background-image:
    linear-gradient(to right, rgb(var(--color-gray-200)) 0.5px, transparent 0.5px),
    linear-gradient(to bottom, rgb(var(--color-gray-200)) 0.5px, transparent 0.5px);
}
.dark {
  .overlay {
    background-image:
      linear-gradient(to right, rgb(var(--color-gray-900)) 0.5px, transparent 0.5px),
      linear-gradient(to bottom, rgb(var(--color-gray-900)) 0.5px, transparent 0.5px);
  }
}
</style>
